/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * Audius API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { TrackId } from './TrackId';
import {
    TrackIdFromJSON,
    TrackIdFromJSONTyped,
    TrackIdToJSON,
} from './TrackId';

/**
 * 
 * @export
 * @interface TrendingTimesIds
 */
export interface TrendingTimesIds {
    /**
     * 
     * @type {Array<TrackId>}
     * @memberof TrendingTimesIds
     */
    week?: Array<TrackId>;
    /**
     * 
     * @type {Array<TrackId>}
     * @memberof TrendingTimesIds
     */
    month?: Array<TrackId>;
    /**
     * 
     * @type {Array<TrackId>}
     * @memberof TrendingTimesIds
     */
    year?: Array<TrackId>;
}

/**
 * Check if a given object implements the TrendingTimesIds interface.
 */
export function instanceOfTrendingTimesIds(value: object): value is TrendingTimesIds {
    let isInstance = true;

    return isInstance;
}

export function TrendingTimesIdsFromJSON(json: any): TrendingTimesIds {
    return TrendingTimesIdsFromJSONTyped(json, false);
}

export function TrendingTimesIdsFromJSONTyped(json: any, ignoreDiscriminator: boolean): TrendingTimesIds {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'week': !exists(json, 'week') ? undefined : ((json['week'] as Array<any>).map(TrackIdFromJSON)),
        'month': !exists(json, 'month') ? undefined : ((json['month'] as Array<any>).map(TrackIdFromJSON)),
        'year': !exists(json, 'year') ? undefined : ((json['year'] as Array<any>).map(TrackIdFromJSON)),
    };
}

export function TrendingTimesIdsToJSON(value?: TrendingTimesIds | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'week': value.week === undefined ? undefined : ((value.week as Array<any>).map(TrackIdToJSON)),
        'month': value.month === undefined ? undefined : ((value.month as Array<any>).map(TrackIdToJSON)),
        'year': value.year === undefined ? undefined : ((value.year as Array<any>).map(TrackIdToJSON)),
    };
}

